export default __webpack_public_path__ + "static/media/G_Gamba.055b933d.mp3";